const ProductMixin = {
  methods: {
    getObjectLength(type) {
      console.log(`Gone for ${type}`);
      const len = Object.keys(this.$store.state.InventoryModule.Products[this.action][type]).length;
      if (len === 0) {
        return 1;
      }
      return len;
    },
  },
};

export default ProductMixin;
